import { saveAs } from 'file-saver';
import { setIsExportingComparison } from '~/redux/reducers/states/comparison_documents';
import { getClassificationComments, getClassificationDiff } from './classification_extract';
import { initializeClassificationColumnsInRow, initializeExcelRows, initializeExcelWorkbook, } from './initialize';
import { addClassificationDivider, addTopLevelClassificationRow, formatCommentsRow, } from './worksheet';
const ExportGridViewDataToXlsx = (tagsColumnNames, anchorDoc, comparisonDocs, documentsComparisonDetail, options, dispatch) => {
    var _a, _b;
    const defaultOptions = { exportDiffs: false, exportPrivilegedComments: true };
    options = Object.assign(Object.assign({}, defaultOptions), options);
    const { workbook, worksheet } = initializeExcelWorkbook(anchorDoc, comparisonDocs, documentsComparisonDetail);
    for (const classificationName of tagsColumnNames) {
        const classificationColumnsInRow = initializeClassificationColumnsInRow(anchorDoc, comparisonDocs, classificationName);
        const totalClassificationColumns = comparisonDocs.length + 2;
        const newExcelRows = initializeExcelRows(classificationName, classificationColumnsInRow, totalClassificationColumns);
        const commentsRow = Array(totalClassificationColumns);
        commentsRow.splice(0, 1, 'Comparison Comments');
        const anchorClauses = classificationColumnsInRow[0];
        const anchorClause = (_b = (_a = anchorClauses[0]) === null || _a === void 0 ? void 0 : _a.classifications) === null || _b === void 0 ? void 0 : _b[0];
        let excelColumnIndex = 1;
        let classificationColumnIndex = 0;
        for (const classificationColumn of classificationColumnsInRow) {
            const isAnchorDoc = classificationColumnIndex === 0;
            if (!isAnchorDoc && !classificationColumn.length && options.exportDiffs) {
                const excelRow = newExcelRows[0];
                excelRow[excelColumnIndex] = getClassificationDiff({ richText: [] }, anchorClause === null || anchorClause === void 0 ? void 0 : anchorClause.text, '');
            }
            let commentAggregates = [];
            let rowIndex = 0;
            for (const clause of classificationColumn) {
                let cell = { richText: [{ text: '' }] };
                for (const classification of clause.classifications) {
                    cell = addClassificationToCell(classificationName, classification, cell, isAnchorDoc, options, anchorClause);
                    commentAggregates = [...commentAggregates, ...getClassificationComments(classification, options.exportPrivilegedComments, options.selectedPrivilegeGroupIds)];
                }
                newExcelRows[rowIndex][excelColumnIndex] = cell;
                rowIndex++;
            }
            commentsRow[excelColumnIndex] = formatCommentsRow(commentAggregates);
            excelColumnIndex++;
            classificationColumnIndex++;
        }
        newExcelRows.push(commentsRow);
        addTopLevelClassificationRow(worksheet, newExcelRows, totalClassificationColumns);
        addClassificationDivider(worksheet, totalClassificationColumns);
    }
    workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, 'document_comparison.xlsx');
        dispatch(setIsExportingComparison(false));
    });
};
const addClassificationToCell = (classificationName, classification, cell, isAnchorDoc, options, anchorClause) => {
    const pageNum = classification.regions.reduce((accum, region) => {
        if (region.pageNum) {
            accum += `(p. ${region.pageNum})`;
        }
        return accum;
    }, '');
    if (classification.name !== classificationName) {
        cell.richText.push({
            font: { bold: true },
            text: `${classification.name} `,
        });
    }
    cell.richText.push({
        font: { italic: true },
        text: `${pageNum}\r\n`,
    });
    if (!isAnchorDoc && options.exportDiffs) {
        cell = getClassificationDiff(cell, anchorClause === null || anchorClause === void 0 ? void 0 : anchorClause.text, classification.text);
        cell.richText.push({
            font: {},
            text: '\r\n\r\n',
        });
    }
    else {
        cell.richText.push({
            font: {},
            text: `${classification.text}\r\n\r\n`,
        });
    }
    return cell;
};
export default ExportGridViewDataToXlsx;
